import { styled } from 'ui';

export const Root = styled('div')(({ theme }) => ({
  alignItems: 'center',
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: '50%',
  display: 'flex',
  height: 60,
  justifyContent: 'center',
  width: 60,
}));
